import { render, staticRenderFns } from "./AlbumTitle.vue?vue&type=template&id=4f2ebe26&"
import script from "./AlbumTitle.vue?vue&type=script&lang=js&"
export * from "./AlbumTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports